import { useState } from "react"
import { useDispatch } from "react-redux"
import Button from "react-bootstrap/Button"

import { FiInfo } from "react-icons/fi"

import { message, projects } from "state_management"
import { Container, Text } from "components/Form"
import { ConfirmDialog } from "components"
import useT from "utils/hooks/useT"
import "./index.scss"

export default function DeleteUnplannedProjects() {
  const { t } = useT("common")
  const dispatch = useDispatch()
  const [deleteConfirm, setDeleteConfirm] = useState(false)
  const [enteredKeyword, setEnteredKeyword] = useState("")

  const deletionKeyword = "DELETE"

  return (
    <>
      {deleteConfirm && (
        <ConfirmDialog
          onCancel={() => {
            setDeleteConfirm(false)
            setEnteredKeyword("")
          }}
          onConfirm={() => {
            if (deletionKeyword !== enteredKeyword) {
              dispatch(message.warning(t("typeBeforeConfirming", { keyword: deletionKeyword })))
              setEnteredKeyword("")
              return
            }
            dispatch(projects.removeAllUnplanned())
            setEnteredKeyword("")
            setDeleteConfirm(false)
          }}
        >
          <Container>
            <div className="DeleteAllUnplannedProjects-info-text">
              <FiInfo title={t("confirmDeleteAllUnplannedProjects")} />
            </div>
            <h4>{t("toConfirmDeletionType", { keyword: deletionKeyword })}</h4>
          </Container>
          <Container>
            <Text value={enteredKeyword} onChange={(e) => setEnteredKeyword(e)} />
          </Container>
        </ConfirmDialog>
      )}
      <div className="DeleteAllUnplannedProjects-container">
        <Button
          variant="danger"
          onClick={() => {
            setDeleteConfirm(true)
          }}
        >
          {t("deleteProjects")}
        </Button>
      </div>
    </>
  )
}
